import { useState } from "react";

export const useDisclosure = (initial = false) => {
  const [open, setOpen] = useState(initial);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);
  const toggle = () => setOpen((nextOpen) => !nextOpen);

  return { open, onOpen, onClose, toggle };
};
